import { makeResource, mapped } from '@codium/codium-vue'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('settings/railAppReleases', {
  namespaced: true,

  resource () {
    return {
      id: null,
      name: mapped(null),
      content: mapped({}),
      status: mapped(null),
      released_at: mapped(null)
    }
  }
})
